import makeId from "../../libs/make-id";
import {attachWarmupStatements} from "./warmups/attach-statements";
import createAndInsertWarmupImages from "./warmups/create-images";
import createAndInsertWarmupStatements from "./warmups/create-statements";
import reloadWarmupsCountOnAllParts from "./reload-warmups-count-on-all-parts";

export function attachWarmups(context) {
    const $context = $(context);
    const warmupImages = $context.find('[data-warmup-item-image]');
    warmupImages.each(function(){
        const randomId = makeId(8);
        $(this).html(
            $(this).html().replaceAll('--WARMUP-CLOUD-ID--', randomId)
        );
    });

    // Check items count (brands*statements) on context
    const statementsCount = $context.find('.statements-quantity').val();

    const images = 'images';
    const statements = 'statements';

    // Check what type warmups should be
    let warmupsTypeShouldBe = (1 === parseInt(statementsCount)) ? images : statements;

    // Check currently set warmups type
    const $currentlySetWarmupsInput = $context.find("input.warmups-type");
    const currentlySetWarmupsType = $currentlySetWarmupsInput.val();

    if (statements === currentlySetWarmupsType) {
        attachWarmupStatements($context);
    }

    const $partCategoryInput = $context.find('.object-choose-radio:checked');
    const partCategories = [
        'category-videos-commercials',
        'category-concept-testing',
        'category-sales-pal',
    ];
    const currentPartCategory = $partCategoryInput.attr('id');

    // Check part is "Concept testing" or "videos & commercials"
    if (partCategories.includes(currentPartCategory)) {
        warmupsTypeShouldBe = statements;
    }

    // Check no need to change anything in warmups
    if (warmupsTypeShouldBe === currentlySetWarmupsType) {
        reloadWarmupsCountOnAllParts();
        return;
    }

    // Show warmups images if there is something else now
    if (images === warmupsTypeShouldBe) {
        createAndInsertWarmupImages($context);
        $currentlySetWarmupsInput.val(images);

        return;
    }

    // Show warmups statements if there is something else now
    $currentlySetWarmupsInput.val(statements);
    attachWarmupStatements($context);
    createAndInsertWarmupStatements($context);
}
